import { ReactElement } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'

const BankConnectScreen = (): ReactElement => {
  return (
    <Flexbox flex={1} isCol>
      <ScreenTitle title={'Bank Connect'} />
      <div>Handle payments from the GUI, check current balance and more</div>
    </Flexbox>
  )
}

export default BankConnectScreen